import PropTypes from "prop-types";
import TopBack from "../../../reservations/components/subcompdash/Topback";

/** "Go back + title" bar with page actions on the right — same as the customer/car detail pages. */
function EmployeePageHeader({ title, onBack, actions }) {
    return (
        <div className="flex shrink-0 flex-wrap items-center justify-between gap-4">
            <div className="flex min-w-0 flex-wrap items-center gap-3">
                <TopBack onBack={onBack} />
                <h1 className="fontbold text-[1.3rem] text-[#2F2F46]">{title}</h1>
            </div>
            {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
        </div>
    );
}

EmployeePageHeader.propTypes = {
    title: PropTypes.node.isRequired,
    onBack: PropTypes.func,
    actions: PropTypes.node,
};

export default EmployeePageHeader;
